import { Stack } from '@astryxdesign/core/Stack'
import { Link } from '@astryxdesign/core/Link'

// The App Store / Play Store badge pair.
//
// Both URLs are props with no defaults, deliberately. The four screens that
// show these badges do not agree on them today:
//
//   Main        apps.apple.com/fr/app/...   play.google.com/store/apps/details?id=...
//   Invitation  apps.apple.com/fr/app/...   play.google.com/apps/testing/...   (not rendered)
//   AppLink     apps.apple.com/fr/app/...   play.google.com/store/apps/details?id=...
//   Profile     apps.apple.com/app/...      play.google.com/apps/testing/...
//
// Two of them point at the Play *testing* track rather than the public
// listing, and Profile's Apple link omits the /fr/ locale the others carry.
// That looks like drift rather than intent, but picking a winner here would be
// changing where a visitor lands, which is not what this migration is for - so
// each caller still passes its own and nothing moves. Worth settling
// separately.
//
// These are links, not buttons. The screens they replace used <button> with
// window.location.href, which is a navigation wearing the wrong element: it
// could not be opened in a new tab, middle-clicked, or reached the way a
// screen reader reaches a link.
// The badges are sized in CSS, not with the img height attribute. Astryx's
// reset sets `img { height: auto }`, which wins over the attribute, so
// height="40" left both badges at their natural size - the App Store one is
// over a thousand pixels wide, and it looked exactly like a broken layout.
//
// isExternalLink is also deliberately not used here. It appends a little
// box-and-arrow glyph beside the link, which is right for a text link and
// clearly wrong hanging off the corner of a store badge. The screens these
// replace navigated in the same tab too, so not opening a new one keeps
// behaviour as it was.
const BADGE = { height: '40px', width: 'auto', display: 'block' }

export function StoreBadges({ appStoreURL, playStoreURL }) {
    return (
        <Stack direction="horizontal" gap={3} wrap="wrap" vAlign="center" hAlign="center">
            {appStoreURL && (
                <Link href={appStoreURL} label="Télécharger dans l'App Store">
                    <img src="/img/download_appstore.png" alt="App Store" style={BADGE} />
                </Link>
            )}
            {playStoreURL && (
                <Link href={playStoreURL} label="Disponible sur Google Play">
                    <img src="/img/download_playstore.png" alt="Google Play" style={BADGE} />
                </Link>
            )}
        </Stack>
    )
}

export default StoreBadges
